import { GhostChip } from './GhostChip'

import type { ShiftWithSlots } from '../shifts/types'

export function PendingRemovalAssignees({ shift }: { shift: ShiftWithSlots }) {
  const assignedSlots = (shift.shiftSlots.nodes ?? []).filter((slot) => slot.supporter)
  if (assignedSlots.length === 0) return null

  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-1.5 tw:opacity-60">
      {assignedSlots.map((slot) => (
        <GhostChip key={slot.id} name={slot.supporter?.fullName ?? ''} />
      ))}
    </div>
  )
}
